/** A full-area loading state in the prototype's style (the onboarding `.spin`). */
export function Spinner({ label = "Loading" }: { label?: string }) {
  return (
    <div className="wp-loading" role="status" aria-live="polite" data-testid="loading">
      <div className="wp-spin" aria-hidden="true" />
      <span>{label}</span>
    </div>
  );
}
